import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import UserTable from "../user-management/UserTable";
import { SearchAndFilterToolbar, StatusBar } from "../common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import enumChoice from "../../enum";
import moment from 'moment';

import { Paginator } from "../../components/common";
import UserFilter from "../user-management/userFilter";
import CreateUserForm from "./create/CreateUserForm";
import { parseSearchParams } from "../common/filterableForm";
import { handleRetriveError } from "../../utils";

interface OrderResponse {
  results: any[]; 
}

function UserMain() {
  const [openUserFilterModal, setOpenUserFilterModal] = useState(false);
  const [users, setUsers] = useState<OrderResponse | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [searchParams, setSearchParams] = useSearchParams();
 

  return (
    <PageBodyWrapper>
      <StatusBar
        onButtonClick={()=>setOpenModal(!openModal)}
        statusList={[]} 
        fieldName="role"
        buttonLabel="Add User"
      />
      <SearchAndFilterToolbar
        onFilterOpen={() => setOpenUserFilterModal(!openUserFilterModal)}
        // onRefresh={fetchUsers}
        startDateKey={"created_at_after"}
        endDateKey={"created_at_before"}

      />
      
      {/* Render OrderFilter when openOrderFilter is true */}
      {openUserFilterModal && <UserFilter  onClose={() => setOpenUserFilterModal(false)} />}
      

      <div className="px-1">
        <UserTable users={users?.results || []}/>
      </div>

      {openModal && (
        <CreateUserForm
          isOpen={openModal} 
          onClose={()=>{setOpenModal(!openModal)}}
        />
      )}

    </PageBodyWrapper>
  );
}

export default UserMain;
